/**
 * Domain enums shared between API and web.
 * Keep values stable — they are persisted in the database and sent over the wire.
 */

export const UserRole = {
  ADMIN: 'ADMIN',
  SALES_AGENT: 'SALES_AGENT',
  SALES_MANAGER: 'SALES_MANAGER',
  DESIGNER: 'DESIGNER',
  TECHNICIAN: 'TECHNICIAN',
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const ProjectStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  ON_HOLD: 'ON_HOLD',
  SENT_TO_CLIENT: 'SENT_TO_CLIENT',
  REOFFER: 'REOFFER',
  ACCEPTED: 'ACCEPTED',
  IN_WARRANTY: 'IN_WARRANTY',
  ARCHIVED: 'ARCHIVED',
  REJECTED: 'REJECTED',
} as const;
export type ProjectStatus = (typeof ProjectStatus)[keyof typeof ProjectStatus];

export const Currency = {
  RON: 'RON',
  EUR: 'EUR',
  USD: 'USD',
} as const;
export type Currency = (typeof Currency)[keyof typeof Currency];

export const Locale = {
  RO: 'ro',
  EN: 'en',
} as const;
export type Locale = (typeof Locale)[keyof typeof Locale];

export const DeliveryAddressType = {
  OFFICE: 'OFFICE',
  WAREHOUSE: 'WAREHOUSE',
  STORE: 'STORE',
} as const;
export type DeliveryAddressType = (typeof DeliveryAddressType)[keyof typeof DeliveryAddressType];

export const CatalogItemType = {
  CABINET: 'CABINET',
  PANEL: 'PANEL',
  COUNTERTOP: 'COUNTERTOP',
  ELEMENT: 'ELEMENT',
  LIGHTING: 'LIGHTING',
  HARDWARE: 'HARDWARE',
  DRAWER: 'DRAWER',
  MATERIAL: 'MATERIAL',
} as const;
export type CatalogItemType = (typeof CatalogItemType)[keyof typeof CatalogItemType];
